module.exports = __webpack_public_path__ + "static/media/ovest5.0279a4fa.svg";